import { ref, computed } from 'vue'
import dayjs from 'dayjs'

export const ANALYST_MODEL_DEFAULT = 1 // 分析模式默认值（多会话分析）
export const OUTPUT_FORMAT_DEFAULT = 1 // 输出格式默认值（Word）
/**
 * 聊天状态管理
 */
export function useChatState({ route }) {
  // 基础状态
  const canSend = ref(true)
  const isStreaming = ref(false)
  const terminationVisible = ref(false)
  const terminationLoading = ref(false)
  const showDrawer = ref(false)
  const terminationVisibleLoading = ref(false)

  // 消息和分页状态
  const messages = ref([])
  const currentPage = ref(1)
  const hasMore = ref(false)

  // 输入状态
  const isShowTemplate = ref(true)
  const analystContent = ref('')
  const isTermination = ref(false) // 是否终止分析
  const wordLimit = ref(1000)
  const enableSearch = ref(false)

  // 筛选条件
  const analysisBusinessType = ref(0) //（员工分析 0 & 其它数据源分析 businessType）
  const customerList = [
    {
      name: '全部数据',
      id: '0'
    }
  ]
  const customer = ref(customerList)
  const analyzeModelOptions = ref([])
  const analyzeModel = ref(ANALYST_MODEL_DEFAULT) // 分析模式选项值
  const outputFormatOptions = ref([])
  const outputFormatValue = ref(OUTPUT_FORMAT_DEFAULT) // 输出格式选项值
  const selectValue = ref([])
  const departmentStaffSelectTabType = ref(2) // 成员/部门选择类型(1:成员；2:部门)
  const dateScope = ref('')
  const roleName = ref('全部部门')
  const shortcuts = [
    // 日期快捷选项（上周、上月、近三个月）
    {
      text: '上周',
      value: () => {
        const now = new Date()
        const day = now.getDay()
        // 计算本周周一（若今天为周一则为今天）
        const diffToMon = (day + 6) % 7
        const thisMon = new Date(
          now.getFullYear(),
          now.getMonth(),
          now.getDate() - diffToMon,
          0,
          0,
          0,
          0
        )
        // 上周周一
        const lastWeekStart = new Date(thisMon.getTime() - 7 * 24 * 3600 * 1000)
        // 上周周日 23:59:59.999
        const lastWeekEnd = new Date(thisMon.getTime() - 1)
        return [lastWeekStart, lastWeekEnd]
      }
    },
    {
      text: '上月',
      value: () => {
        const now = new Date()
        // 本月第一天
        const thisMonthStart = new Date(now.getFullYear(), now.getMonth(), 1, 0, 0, 0, 0)
        // 上月第一天
        const lastMonthStart = new Date(now.getFullYear(), now.getMonth() - 1, 1, 0, 0, 0, 0)
        // 上月最后一刻：本月第一天的前一毫秒
        const lastMonthEnd = new Date(thisMonthStart.getTime() - 1)
        return [lastMonthStart, lastMonthEnd]
      }
    },
    {
      text: '近三个月',
      value: () => {
        const end = new Date()
        const start = new Date()
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
        return [start, end]
      }
    }
  ]

  // 其他状态
  const chatRecordId = ref('')
  const mainTitle = ref('')

  // 计算筛选参数
  const conditionParams = computed(() => {
    const params = {
      startTime: dateScope.value?.length && Math.floor(dateScope.value[0].getTime() / 1000),
      endTime: dateScope.value?.length && Math.floor(dateScope.value[1].getTime() / 1000)
    }

    params.userRangePojoList = selectValue.value

    if (customer.value?.id && customer.value.id !== '0') {
      params.customerId = customer.value.id
    }

    return params
  })

  /**
   * 获取近 7 天的时间范围（含今天）
   */
  const getLast7Days = () => {
    const now = new Date()
    // 结束时间设为当天 23:59:59.999
    const end = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59, 999)
    // 开始时间为 6 天前的 00:00:00
    const start = new Date(now.getTime() - 6 * 24 * 3600 * 1000)
    start.setHours(0, 0, 0, 0)
    return [start, end]
  }
  // 清空输入内容
  const clearInput = () => {
    analystContent.value = ''
  }
  // 格式化时间显示
  const formatTime = (timestamp) => {
    const date = dayjs(timestamp * 1000)
    const today = dayjs().startOf('day')

    if (date.isSame(today, 'day')) {
      // 如果是今天，只显示时间
      return date.format('HH:mm')
    } else {
      // 如果不是今天，显示完整日期时间
      return date.format('YYYY-MM-DD HH:mm')
    }
  }

  return {
    // 基础状态
    canSend,
    isStreaming,
    terminationVisible,
    terminationLoading,
    showDrawer,
    terminationVisibleLoading,

    // 消息和分页状态
    messages,
    currentPage,
    hasMore,

    // 输入状态
    isShowTemplate,
    analystContent,
    isTermination,
    wordLimit,
    enableSearch,

    // 筛选条件
    analysisBusinessType,
    customer,
    analyzeModelOptions,
    analyzeModel,
    outputFormatOptions,
    outputFormatValue,
    selectValue,
    departmentStaffSelectTabType,
    dateScope,
    roleName,

    // 其他状态
    chatRecordId,
    mainTitle,

    // 计算属性
    shortcuts,
    conditionParams,

    // 方法
    getLast7Days,
    clearInput,
    formatTime
  }
}
